export class ChangePasswordRequest{
     eMail?: string;
     oldPassword?: string;
     resetPasswordKey?: string;
     newPassword?: string;
     captchaCode?: string;
     clientType?: string;
}